import type { Product, ProductDisplaySettings } from '../types/menu';
import { escapeHtml, formatPortion, formatPrice, imageStyle } from '../utils/helpers';

export function productCard(product: Product, compact = false, display: ProductDisplaySettings = { badge: '', unavailable: false }) {
  const portion = formatPortion(product.portion, product.unit);
  return `<article class="product-card ${compact ? 'product-card--compact' : ''} ${display.unavailable ? 'is-unavailable' : ''}" data-action="${display.unavailable ? '' : 'open-product'}" data-product-id="${escapeHtml(product.id)}" ${imageStyle(product.image, display.imagePosition)}>
    <div class="product-card__image">${display.badge ? `<span class="product-card__badge">${escapeHtml(display.badge)}</span>` : ''}</div>
    <div class="product-card__content">
      <h3 title="${escapeHtml(product.name)}">${escapeHtml(product.name)}</h3>
      ${portion ? `<span class="product-card__portion">${escapeHtml(portion)}</span>` : ''}
      <strong class="product-card__price">${formatPrice(product.price_rub)}</strong>
    </div>
    ${display.unavailable ? '<img class="product-card__stop-stamp" src="/images/stop-list-stamp.png" alt="Стоп-лист">' : ''}
  </article>`;
}
